interface EmptyTemplateProps {
    image?: string;
    text: string;
    align?: 'center' | 'left' | 'right';
    orientation?: 'column' | 'column-reverse' | 'row' | 'row-reverse';
    id?: string;
}

export const EmptyTemplate: React.FC<EmptyTemplateProps> = ({
    image,
    text,
    align='center',
    orientation='column',
    id='align-box-empty-template',
}) => {

    return (
        // BOX PARA LA ALINEACIÓN HORIZONTAL
        <div
            id={id}
            className='flex my-3'
            style={{
                justifyContent: align,
                width: 'calc(100vw - 288px)',
            }}
        >
            {/* BOX PARA LA ORIENTACIÓN */}
            <div
                id='orientation-box'
                className={`flex flex-${orientation}`}
                style={{
                    justifyContent: align,
                    alignItems: orientation.includes('column') ? (() => {switch (align) {
                        case "left":
                            return 'flex-start'
                        case 'right':
                            return 'flex-end'
                        default:
                            return 'center'
                    }})() : 'center',
                    gap: 'var(--padding-level-sixteen)',
                }}
            >
                {/* ELEMENTOS DEL TEMPLATE */}
                {
                    image &&
                        <div className="flex justify-content-center w-full">
                            <img
                                id='empty-template-image'
                                src={image}
                                alt='empty template image'
                                style={{
                                    width: '100px',
                                }}
                            />
                        </div>
                }
                <div className="flex justify-content-center w-full">
                    <p
                        style={{
                            // textWrap: 'wrap',
                            textAlign: 'center',
                            fontFamily: 'var(--fontBarlowSemiBold)',
                            fontSize: 'var(--font-size-md)',
                            color: 'var(--labelsAndTextColorShade50)',
                            width: '248px',
                        }}
                    >
                        {text}
                    </p>
                </div>
            </div>
        </div>
    )
}